export default __webpack_public_path__ + "static/media/rage.be6751f0.mp4";